import styled from "@emotion/styled";

export const UploadImageContainer = styled.div`
  border-radius: 6px;
  height: 100%;
  width: 100px;
  min-height: 100px;
  margin-block: 10px;
  border: 1px solid #dedede;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: black;
  overflow: hidden;
  cursor: pointer;
`;

export const InputSearchRounded = styled.input`
  height: 35px;
  width: 350px;
  max-width: 60vw;
  border-radius: 20px;
  border: 2px solid #dedede;
  background-color: #faf7f7;
  padding-left: 40px;
`;

export const InputSearchRoundedIcon = styled.div`
  left: 3%;
  top: 20%;
  position: absolute;
`;
